import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/welcome/Documents/NKS/A0. Projects/sunny-business-card/components/BusinessCard/BusinessCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/welcome/Documents/NKS/A0. Projects/sunny-business-card/components/BusinessCard/BusinessCard01.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/welcome/Documents/NKS/A0. Projects/sunny-business-card/components/BusinessCard/BusinessCard02.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/welcome/Documents/NKS/A0. Projects/sunny-business-card/components/Chat/index.tsx");
